import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberJourneyListDisplayText = {
    foodAndDrinkJourneyTitle: 'Food & drink order',
    multiShowtimeJourneyTitleFormat: '${firstFilmTitle} + ${additionalShowtimeCount} others',
    nextGroupLabel: 'Up next',
    itemOnlyGroupLabel: 'Food & drink',
    lastWeekGroupLabel: 'Last week',
    monthGroupFormat: '${date|d|MMMM YYYY}',
    siteNameLabel: 'Cinema',
    timeLabel: 'Time',
    timeFormat: '${startTime|d|HH:mm}',
    dateLabel: 'Date',
    dateFormat: '${startTime|d|MMMM DD, YYYY}',
    refundedTagLabel: 'Refunded',
    quantitySummaryFormat: '${quantity} x',
    viewTicketJourneyButtonLabel: 'View ticket',
    viewFoodAndDrinkJourneyButtonLabel: 'View order',
    loadMoreButtonLabel: 'Load more',
    noActiveJourneysTitle: "You don't have any upcoming bookings.",
    noActiveJourneysMessage: 'Bookings for showtimes in the future will be shown here.',
    noRecentJourneysTitle: "You don't have any recent bookings.",
    noRecentJourneysMessage: 'Past bookings will be shown here.',
    noJourneysActionButtonLabel: 'Browse films',
    failedToLoadMoreJourneysMessage: 'Failed to load more journeys.',
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser to try loading your transactions again.'
};
export const memberJourneyListDisplayTextValidator = Validator.object({
    foodAndDrinkJourneyTitle: nonEmptyStringValidator,
    multiShowtimeJourneyTitleFormat: nonEmptyStringValidator,
    nextGroupLabel: nonEmptyStringValidator,
    itemOnlyGroupLabel: nonEmptyStringValidator,
    lastWeekGroupLabel: nonEmptyStringValidator,
    monthGroupFormat: nonEmptyStringValidator,
    siteNameLabel: nonEmptyStringValidator,
    timeLabel: nonEmptyStringValidator,
    timeFormat: nonEmptyStringValidator,
    dateLabel: nonEmptyStringValidator,
    dateFormat: nonEmptyStringValidator,
    refundedTagLabel: nonEmptyStringValidator,
    quantitySummaryFormat: nonEmptyStringValidator,
    viewTicketJourneyButtonLabel: nonEmptyStringValidator,
    viewFoodAndDrinkJourneyButtonLabel: nonEmptyStringValidator,
    loadMoreButtonLabel: nonEmptyStringValidator,
    noActiveJourneysTitle: nonEmptyStringValidator,
    noActiveJourneysMessage: nonEmptyStringValidator,
    noRecentJourneysTitle: nonEmptyStringValidator,
    noRecentJourneysMessage: nonEmptyStringValidator,
    noJourneysActionButtonLabel: nonEmptyStringValidator,
    failedToLoadMoreJourneysMessage: nonEmptyStringValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator
});
